import { Flip, toast } from 'react-toastify';

export const onTriggerError = message => {
  toast.error(
    message ||
      `Sorry, we encountered an error. Please try again later. If the issue persists, kindly contact our support team for further assistance.`,
    {
      position: 'top-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
      transition: Flip,
    }
  );
};

export const onTriggerSuccess = message => {
  toast.success(message || 'Success', {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    transition: Flip,
  });
};
